import { BigTitle } from 'shared/components/BigTitle';
import { Block } from 'shared/components/Block';
import { Description } from 'shared/components/Description';
import { Wrapper } from 'shared/components/Wrapper';
import * as styles from './styles.css';
import { DESCRIPTION, LIST } from './constants';
import { clsx } from 'clsx';
import { useDeviceType } from '@cian/ui-kit';

export const GrowthDrivers: React.FC = () => {
  const device = useDeviceType();

  return (
    <div>
      <Wrapper withoutPaddingBottom>
        <Block>
          <BigTitle text="Про драйверы роста" />
          <Description text={DESCRIPTION} />
          <div className={clsx(styles['list'], styles[device])}>
            {LIST.map(({ title, descrList, image }, key) => (
              <div key={key} className={styles['list-item']}>
                <div className={clsx(styles['list-image'], styles[image])} />
                <div className={styles['textblock']}>
                  <div className={styles['item-title']}>{title}</div>
                  <ul className={styles['descr-list']}>
                    {descrList.map((descr, descrKey) => (
                      <li className={styles['item-descr']} key={descrKey}>
                        {descr}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </Block>
      </Wrapper>
    </div>
  );
};
